package com.flowyride.core.device

import com.flowyride.core.domain.navigation.NavigationPreferences
import com.russhwolf.settings.Settings
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

/** [NavigationPreferences] in the platform's app preferences (SharedPreferences, NSUserDefaults, localStorage). */
class NavigationSettings(open: () -> Settings = { Settings() }) : NavigationPreferences {

    // Opened on first use. Unavailable storage (host tests: no Android context) keeps the choices in memory.
    private val settings: Settings? by lazy { runCatching(open).getOrNull() }

    private val _speedCameraAlerts: MutableStateFlow<Boolean> by lazy {
        MutableStateFlow(settings?.getBoolean(KEY_CAMERA_ALERTS, false) ?: false)
    }

    override val speedCameraAlerts: StateFlow<Boolean> get() = _speedCameraAlerts.asStateFlow()

    override fun setSpeedCameraAlerts(enabled: Boolean) {
        settings?.putBoolean(KEY_CAMERA_ALERTS, enabled)
        _speedCameraAlerts.value = enabled
    }

    private companion object {
        const val KEY_CAMERA_ALERTS = "flowyride.navigation.speedCameraAlerts"
    }
}
